import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `http://jtqzai.cn/${item.href}` : undefined,
    })),
  };

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-8 py-3">
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <ol className="flex items-center gap-2 flex-wrap text-sm">
        <li>
          <Link
            to="/"
            className="text-foreground-500 hover:text-primary-400 transition-colors"
          >
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            <span className="text-foreground-700">
              <i className="ri-arrow-right-s-line" />
            </span>
            {item.href && index < items.length - 1 ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-400 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-300 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}